import { styled } from '@mui/material';
import { NavLink } from 'react-router-dom';

const opacityOpenMixin = theme => ({
  transition: theme.transitions.create(['opacity'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  opacity: 1,
});

const opacityClosedMixin = theme => ({
  transition: theme.transitions.create(['opacity'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  opacity: 0,
});

const SidebarLink = styled(NavLink, {
  name: 'Sidebar',
  slot: 'link',
  shouldForwardProp: prop => !['sidebarOpen', 'sx'].includes(prop),
})(({ theme }) => ({
  fontSize: '15px',
  fontWeight: 600,
  fontFamily: 'Manrope',
  display: 'flex',
  alignItems: 'center',
  padding: '12px',
  borderRadius: '4px',
  width: '226px',
  overflowX: 'hidden',
  '& svg': {
    width: '22px',
  },
  variants: [
    {
      props: ({ sidebarOpen }) => sidebarOpen,
      style: { ...opacityOpenMixin(theme) },
    },
    {
      props: ({ sidebarOpen }) => !sidebarOpen,
      style: { ...opacityClosedMixin(theme) },
    },
  ],
}));

export default SidebarLink;
